import { render, staticRenderFns } from "./Impersonate.vue?vue&type=template&id=0daa998d&scoped=true"
import script from "./Impersonate.vue?vue&type=script&lang=js"
export * from "./Impersonate.vue?vue&type=script&lang=js"
import style0 from "./Impersonate.vue?vue&type=style&index=0&id=0daa998d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daa998d",
  null
  
)

export default component.exports